export const routes = [
  {
    path: '/:path(.*)',
    name: 'notfound',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/[...path].vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/about.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'agencies',
        /* internal name: '/admin/agencies' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'admin-agencies',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/agencies/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'agreement-templates',
        /* internal name: '/admin/agreement-templates' */
        /* no component */
        children: [
          {
            path: '',
            name: 'agreement-templates',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/agreement-templates/index.vue'),
            /* no children */
          },
          {
            path: ':agreementTemplateId',
            name: 'agreement-template:edit',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/agreement-templates/[agreementTemplateId].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'agreement-template:create',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/agreement-templates/create.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'courses',
        /* internal name: '/admin/courses' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'admin-programs',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/courses/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'document-types',
        name: 'document-types',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/document-types.vue'),
        /* no children */
      },
      {
        path: 'packages',
        /* internal name: '/admin/packages' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'admin-packages',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/packages/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'program-levels',
        name: 'program-levels',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/program-levels.vue'),
        /* no children */
      },
      {
        path: 'qualification-levels',
        name: 'qualification-levels',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/qualification-levels.vue'),
        /* no children */
      },
      {
        path: 'schools',
        /* internal name: '/admin/schools' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'admin-schools',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/schools/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/settings.vue'),
        /* no children */
      },
      {
        path: 'students',
        /* internal name: '/admin/students' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'admin-students',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/students/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'users',
        /* internal name: '/admin/users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-users',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/users/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'utils',
        name: 'admin-utils',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/admin/utils.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'agent-register',
        name: 'agent-register',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/auth/agent-register.vue'),
        /* no children */
        meta: {
          "layout": "unauth"
        }
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/auth/forgot-password.vue'),
        /* no children */
        meta: {
          "layout": "unauth"
        }
      },
      {
        path: 'login',
        name: 'login',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/auth/login.vue'),
        alias: ["/"],
        /* no children */
        meta: {
          "layout": "unauth"
        }
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/auth/reset-password.vue'),
        /* no children */
        meta: {
          "layout": "unauth"
        }
      },
      {
        path: 'school-register',
        name: 'school-register',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/auth/school-register.vue'),
        /* no children */
        meta: {
          "layout": "unauth"
        }
      },
      {
        path: 'student-register',
        name: 'student-register',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/auth/student-register.vue'),
        /* no children */
        meta: {
          "layout": "unauth"
        }
      }
    ],
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/changelog.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/contact.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/home',
    name: 'landing',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/home.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/privacy.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/services.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/tos',
    name: 'terms-of-use',
    component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/tos.vue'),
    /* no children */
    meta: {
      "layout": "unauth"
    }
  },
  {
    path: '/u',
    /* internal name: '/u' */
    /* no component */
    children: [
      {
        path: 'account',
        name: 'account',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/account.vue'),
        /* no children */
      },
      {
        path: 'agencies',
        /* internal name: '/u/agencies' */
        /* no component */
        children: [
          {
            path: '',
            name: 'my-agencies',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/agencies/index.vue'),
            /* no children */
          },
          {
            path: ':agencyId',
            name: 'manage-agency',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/agencies/[agencyId].vue'),
            /* no children */
          },
          {
            path: ':agencyId/public',
            name: 'public-agency',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/agencies/[agencyId].public.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'applications',
        /* internal name: '/u/applications' */
        /* no component */
        children: [
          {
            path: '',
            name: 'manage-applications',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/applications/index.vue'),
            /* no children */
          },
          {
            path: ':applicationId',
            name: 'manage-application',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/applications/[applicationId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'bookings',
        /* internal name: '/u/bookings' */
        /* no component */
        children: [
          {
            path: '',
            name: 'bookings:list',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/bookings/index.vue'),
            /* no children */
          },
          {
            path: 'availability',
            name: 'bookings:availability',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/bookings/availability.vue'),
            /* no children */
          },
          {
            path: 'new',
            name: 'bookings:new',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/bookings/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'campuses',
        /* internal name: '/u/campuses' */
        /* no component */
        children: [
          {
            path: ':campusId',
            name: 'manage-campus',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/campuses/[campusId].vue'),
            /* no children */
          },
          {
            path: ':campusId/public',
            name: 'public-campus',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/campuses/[campusId].public.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'commissions',
        /* internal name: '/u/commissions' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: 'edit-commission',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/commissions/edit.vue'),
            /* no children */
          },
          {
            path: 'list',
            name: 'list-commission',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/commissions/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'companies',
        /* internal name: '/u/companies' */
        /* no component */
        children: [
          {
            path: ':companyId',
            /* internal name: '/u/companies/[companyId]' */
            /* no component */
            children: [
              {
                path: '',
                name: 'view-company',
                component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/companies/[companyId]/index.vue'),
                /* no children */
              },
              {
                path: 'onboard',
                name: 'onboard-company',
                component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/companies/[companyId]/onboard.vue'),
                /* no children */
              }
            ],
          },
          {
            path: ':companyId/public',
            name: 'public-company',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/companies/[companyId].public.vue'),
            /* no children */
          },
          {
            path: 'branches',
            /* internal name: '/u/companies/branches' */
            /* no component */
            children: [
              {
                path: ':branchId',
                name: 'manage-branch',
                component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/companies/branches/[branchId].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'courses',
        /* internal name: '/u/courses' */
        /* no component */
        children: [
          {
            path: '',
            name: 'manage-programs',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/courses/index.vue'),
            /* no children */
          },
          {
            path: ':programId',
            name: 'manage-program',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/courses/[programId].vue'),
            /* no children */
          },
          {
            path: ':programId/public',
            name: 'public-program',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/courses/[programId].public.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/dashboard.vue'),
        /* no children */
      },
      {
        path: 'document-drafts',
        /* internal name: '/u/document-drafts' */
        /* no component */
        children: [
          {
            path: ':documentDraftId',
            name: 'document-draft:edit',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/document-drafts/[documentDraftId].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'document-draft:create',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/document-drafts/create.vue'),
            /* no children */
          },
          {
            path: 'manage',
            name: 'document-drafts:manage',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/document-drafts/manage.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email',
        /* internal name: '/u/email' */
        /* no component */
        children: [
          {
            path: '',
            name: 'email:inbox',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/email/index.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'email:settings',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/email/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'explore',
        /* internal name: '/u/explore' */
        /* no component */
        children: [
          {
            path: 'agencies',
            name: 'explore-agencies',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/explore/agencies.vue'),
            /* no children */
          },
          {
            path: 'courses',
            name: 'explore-courses',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/explore/courses.vue'),
            /* no children */
          },
          {
            path: 'schools',
            name: 'explore-schools',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/explore/schools.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'messages',
        /* internal name: '/u/messages' */
        /* no component */
        children: [
          {
            path: '',
            name: 'all-conversations',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/messages/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'onboarding',
        name: 'onboarding',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/onboarding.vue'),
        /* no children */
        meta: {
          "layout": "none"
        }
      },
      {
        path: 'packages',
        /* internal name: '/u/packages' */
        /* no component */
        children: [
          {
            path: '',
            name: 'manage-packages',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/packages/index.vue'),
            /* no children */
          },
          {
            path: ':packageId',
            name: 'manage-package',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/packages/[packageId].vue'),
            /* no children */
          },
          {
            path: ':packageId/public',
            name: 'public-package',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/packages/[packageId].public.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'partners',
        /* internal name: '/u/partners' */
        /* no component */
        children: [
          {
            path: 'my',
            name: 'manage-partners',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/partners/my.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'payment-plans',
        /* internal name: '/u/payment-plans' */
        /* no component */
        children: [
          {
            path: '',
            name: 'manage-payment-plans',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/payment-plans/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'payments',
        /* internal name: '/u/payments' */
        /* no component */
        children: [
          {
            path: 'verification',
            name: 'payments:verification',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/payments/verification.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'reports',
        /* internal name: '/u/reports' */
        /* no component */
        children: [
          {
            path: 'accounts',
            name: 'report-accounts',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/reports/accounts.vue'),
            /* no children */
          },
          {
            path: 'payouts',
            name: 'manage-payouts',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/reports/payouts.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'services',
        /* internal name: '/u/services' */
        /* no component */
        children: [
          {
            path: '',
            name: 'services:manage',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/services/index.vue'),
            /* no children */
          },
          {
            path: ':serviceId',
            name: 'services:edit',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/services/[serviceId].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'services:create',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/services/create.vue'),
            /* no children */
          },
          {
            path: 'new',
            name: 'services:new',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/services/new.vue'),
            /* no children */
          },
          {
            path: 'templates',
            /* internal name: '/u/services/templates' */
            /* no component */
            children: [
              {
                path: '',
                name: 'service-templates:manage',
                component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/services/templates/index.vue'),
                /* no children */
              },
              {
                path: ':serviceTemplateId',
                name: 'service-templates:edit',
                component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/services/templates/[serviceTemplateId].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'settings',
        /* internal name: '/u/settings' */
        /* no component */
        children: [
          {
            path: 'webview/:webviewId',
            name: 'edit-webview',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/settings/webview.[webviewId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'students',
        /* internal name: '/u/students' */
        /* no component */
        children: [
          {
            path: ':studentId',
            name: 'manage-student',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/students/[studentId].vue'),
            /* no children */
          },
          {
            path: ':studentId/resume',
            name: 'student-resume',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/students/[studentId].resume.vue'),
            /* no children */
          },
          {
            path: 'add',
            name: 'add-students',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/students/add.vue'),
            /* no children */
          },
          {
            path: 'import',
            name: 'import-students',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/students/import.vue'),
            /* no children */
          },
          {
            path: 'invite',
            name: 'invite-students',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/students/invite.vue'),
            /* no children */
          },
          {
            path: 'list',
            name: 'list-students',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/students/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sub-agents',
        /* internal name: '/u/sub-agents' */
        /* no component */
        children: [
          {
            path: ':subAgentId',
            name: 'sub-agents:edit',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/sub-agents/[subAgentId].vue'),
            /* no children */
          },
          {
            path: 'add',
            name: 'sub-agents:add',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/sub-agents/add.vue'),
            /* no children */
          },
          {
            path: 'commissions',
            name: 'sub-agents:commissions',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/sub-agents/commissions.vue'),
            /* no children */
          },
          {
            path: 'invoices',
            name: 'sub-agents:invoices',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/sub-agents/invoices.vue'),
            /* no children */
          },
          {
            path: 'list',
            name: 'sub-agents:list',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/sub-agents/list.vue'),
            /* no children */
          },
          {
            path: 'referral',
            name: 'sub-agents:referral',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/sub-agents/referral.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'tasks',
        /* internal name: '/u/tasks' */
        /* no component */
        children: [
          {
            path: '',
            name: 'tasks:dashboard',
            component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/tasks/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'visa-processing',
        name: 'visa-processing',
        component: () => import('/builds/clients/harkirat-rai/edumetic/spa-frontend/src/pages/u/visa-processing.vue'),
        /* no children */
      }
    ],
  }
]
